// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1gQxu","question":"Question_question__2DRpR","description":"Question_description__2rmf5"};